import React, { createContext, useContext } from 'react'

import type { PartnerAccountDataActions } from './types'

const PartnerAccountDataActionsContext =
  createContext<PartnerAccountDataActions | null>(null)

export { PartnerAccountDataActionsContext }

export interface PartnerAccountDataActionsProviderProps {
  actions: PartnerAccountDataActions
  children: React.ReactNode
}

export const PartnerAccountDataActionsProvider: React.FC<
  PartnerAccountDataActionsProviderProps
> = ({ actions, children }) => (
  <PartnerAccountDataActionsContext.Provider value={actions}>
    {children}
  </PartnerAccountDataActionsContext.Provider>
)

export const usePartnerAccountDataActions = (): PartnerAccountDataActions => {
  const actions = useContext(PartnerAccountDataActionsContext)
  if (!actions) {
    throw new Error(
      'PartnerAccountDataActionsProvider is required. Wrap your app with PartnerAccountDataActionsProvider or use createPartnerAccountDataProvider().'
    )
  }
  return actions
}
